import {
    getCatelogListAPI,
    getCatelogByIdAPI,
    getMusicLinksAPI,
    fetchMusicLinksAPI
} from "./api"

export function getCatelogList(data) {
    return new Promise((resolve, reject) => {
        getCatelogListAPI(data).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getCatelogById(id) {
    return new Promise((resolve, reject) => {
        getCatelogByIdAPI(id).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getMusicLinks(audio_id) {
    return new Promise((resolve, reject) => {
        getMusicLinksAPI(audio_id).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function fetchMusicLinks(audio_id) {
    return new Promise((resolve, reject) => {
        fetchMusicLinksAPI(audio_id).then((res) => resolve(res)).catch(err => reject(err))
    })
}